import { analytics } from "../../../firebase";
import { configData } from "../../utils/config"

export const googleAnalyticsFn = (event) => {
    analytics.logEvent(`w_${configData.APP_NAME}_${event}`);
}
